import { useMemo } from 'react';

import { matchPath } from '@kc-console/core';

import { getLayoutVisibleByRoute, getLayoutVisibleByStatusCode } from '../utils';
import useRouter from './useRouter';
import useServiceAppState from './useServiceAppState';
import useServiceMetaQuery from './useServiceMetaQuery';

const useLayoutVisible = () => {
  const {
    state: { status: appStatus, serviceKeyword },
  } = useServiceAppState();
  const router = useRouter();
  const { data: serviceMeta } = useServiceMetaQuery();
  const { routes = [] } = serviceMeta || {};

  const urlMatchedRoute = useMemo(() => {
    const pathname = router.asPath.split('?')[0];
    const routePath = pathname.replace(`${serviceKeyword}/`, '');
    return routes?.find(route => matchPath(routePath, route.path)) || null;
  }, [router.asPath, routes, serviceKeyword]);

  return useMemo(() => {
    const layoutVisibleByStatusCode = getLayoutVisibleByStatusCode(appStatus);
    if (layoutVisibleByStatusCode) {
      return layoutVisibleByStatusCode;
    }

    if (urlMatchedRoute) {
      const layoutVisibleByRoute = getLayoutVisibleByRoute(urlMatchedRoute);
      if (layoutVisibleByRoute) {
        return layoutVisibleByRoute;
      }
    }

    return { gnb: true, lnb: true };
  }, [appStatus, urlMatchedRoute]);
};

export default useLayoutVisible;
